import { render, staticRenderFns } from "./BusinessW2Forms.vue?vue&type=template&id=2520bb96&scoped=true&"
import script from "./BusinessW2Forms.vue?vue&type=script&lang=ts&"
export * from "./BusinessW2Forms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2520bb96",
  null
  
)

export default component.exports